export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9289.d35ecbb1.jpg";